<div class="pt-60 md:pt-80 lg:pt-100 pb-60 md:pb-80 lg:pb-100">
    <div class="container">
        <div class="text-center">
            <img src="./assets/img/not-found/error.png" class="inline-block mb-10" alt="error-image">
            <h3 class="font-bold text-18px md:text-20px lg:text-24px mb-15 lg:mb-18">Oops! That page can't be found</h3>
            <p class="md:max-w-[510px] md:ml-auto md:mr-auto leading-7 md:leading-8 text-optional-color mb-10 md:mb-15 text-13px md:text-15px lg:text-16px">The page you are looking for might have been removed had its name changed or is temporarily unavailable.</p>
            <a href="https://pre.solfium.com"
                class="inline-block font-semibold text-13px md:text-14px lg:text-15px mt-10 rounded-sm text-white pt-17 pb-13 pl-35 pr-35 bg-secondary-gradient-color shadow-custom-box-shadow hover:shadow-secondary-btn ease-in duration-300">Back to Home</a>
        </div>
    </div>
</div>
